import React, { useEffect } from 'react';
import { connect, } from 'react-redux';
import {
    sampleSize as _samplesize,
    shuffle as _shuffle,
} from 'lodash';
import { useParams } from 'react-router-dom';

import '../../scss/WordGrid.scss';
import WordBlock from '../components/WordBlock';
import WordLists from '../constants/WordLists';
import GridSizes from '../constants/GridSizes';
import {
    setDisplayedList as setDisplayedListAction,
    setCurrentGridSize as setCurrentGridSizeAction,
    setCurrentWordListId as setCurrentWordListIdAction,
} from '../actions';


const WordGrid = ({ currentGridSize, displayedList, changeGridSizeBySlug, changeListBySlug, currentWordListId, customListAsString, isShuffled, setDisplayedList }) => {
    
    //Grab grid size from url and set it to be the currentGridSize
    const { gridSizeInSlug } = useParams();
        if (typeof GridSizes[gridSizeInSlug] !== "undefined" && currentGridSize !== gridSizeInSlug) {
        changeGridSizeBySlug(gridSizeInSlug)
    }

    //Grab list name from url and set it to be the currentList
    const { listIdInSlug } = useParams();
    if (typeof WordLists[listIdInSlug] !== "undefined" && currentWordListId !== listIdInSlug) {
        changeListBySlug(listIdInSlug)
    }

    useEffect(() => {
       
        const chosenGridArea = GridSizes[currentGridSize].gridArea;

        let listToDisplay = [];
        
        currentWordListId !== "custom"
            ? listToDisplay = [...WordLists[currentWordListId]["listContents"]]
            : listToDisplay = [...customListAsString.split("\n")];

        if (currentGridSize !== '4x4' && listToDisplay.length !== chosenGridArea) {
            listToDisplay = [..._samplesize(listToDisplay, (chosenGridArea))];
        }

        if (isShuffled) {
            listToDisplay = [..._shuffle(listToDisplay)];
        }
        
        setDisplayedList(listToDisplay);
    }, [currentGridSize, currentWordListId, customListAsString, isShuffled, setDisplayedList])
    
    
    return(
        // thoughts on inline styling like this?                            
        <div id="wordGrid" style={ {gridTemplateColumns: `repeat(${GridSizes[currentGridSize].gridNumCols}, 1fr)`} }>
            {displayedList.map(item =>
                <WordBlock
                    key={item.toString()}
                    item={item}
                />
            )}
        </div>
    )
}

const mapStateToProps = state => ({
    currentWordListId: state.currentWordListIdState,
    customListAsString: state.customListState,
    currentGridSize: state.currentGridSizeState,
    isShuffled: state.toggleShuffleState,
    displayedList: state.displayedListState,
})

const mapDispatchToProps = dispatch => ({
    setDisplayedList: list  => dispatch(setDisplayedListAction(list)),
    changeGridSizeBySlug: list => dispatch(setCurrentGridSizeAction(list)),
    changeListBySlug: list => dispatch(setCurrentWordListIdAction(list)),
})

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(WordGrid);